/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext, useEffect } from 'react';
import {
    object, string, shape, func, arrayOf, number, bool,

} from 'prop-types';
import QueryString from 'qs';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Media from 'react-media';
import mbpLogger from '@module-logger/mbp';
import { useSelector } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { getActiveABTest } from '../../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import CommonRadioGroup from './CommonRadioGroup';
import { clubComponentType } from '../common/types';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import { getSSRDeviceType } from '../../../../../../state/ducks/App/App-Selectors';
import ProductReview from '../ProductReview';

const styles = (theme) => ({
    paperBody: {
        boxSizing: 'border-box',
        marginBottom: '20px',
    },
    listItem: {
        marginTop: '10px',
        marginBottom: '10px',
        paddingRight: '5px',
        alignItems: 'center',
    },
    skuLabelName: {
        color: theme.palette.common?.black,
        fontSize: theme?.typography?.pdpSkuLabel?.fontSize || 'inherit',
        [theme.breakpoints.down('sm')]: {
            fontSize: '.8em',
        },
    },
    skuLabelProdId: {
        textAlign: 'center',
        fontSize: '14px',
    },
    skuLabelAmount: {
        color: theme.palette.cms?.skuLabelAmountColor,
        textAlign: 'right',
        fontSize: '14px',
        position: 'relative',
    },
    selctedSkuLabelAmount: {
        position: 'relative',
        textAlign: 'right',
    },
    formControlLabel: {
        width: '100%',
    },
    formControlRoot: {
        borderBottom: `1px solid ${theme.palette.cms?.skuBorderColor || '#c6b66f'}`,
        '&:hover': {
            backgroundColor: theme.palette.cms?.skuLabelTransitionColor || '#ebebde',
            transition: 'background .3s',
        },
        height: 'auto',
        padding: '0 10px',
        marginRight: '0',
    },
    availableToShipText: {
        fontSize: '12px',
        color: theme.palette.cms?.skuAvailableToShipTextColor || theme.palette.colorNeutral70 || '#757575',
        fontWeight: '700',
    },
    rootUpsell: {
        marginTop: '-40px',
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: theme.palette.cms?.skuUncheckedRadioColor,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: theme.palette.cms?.skuRadioHoverColor,
        },
    },
    checkedIcon: {
        backgroundColor: theme.palette.cms?.skuCheckedRadioColor || '#ff9900',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: theme.palette.cms?.skuCheckedRadioColor || '#ff9900',
        },
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        fontWeight: '400',
        fontSize: '18px',
        [theme.breakpoints.down('sm')]: {
            right: '50px',
            fontSize: '.8em',
        },
        [theme.breakpoints.down('xs')]: {
            position: 'unset',
            fontSize: '14px',
            display: 'block',
        },
    },

    salePrice: {
        color: theme.palette.pdp.salePrice || '#a1001a',
        margin: '0 0 0 10px',
        fontSize: '20px',
        fontWeight: '700',
        [theme.breakpoints.down('sm')]: {
            position: 'unset',
            display: 'block',
        },
    },
    selectedSalePrice: {
        fontWeight: 'bold',
        fontSize: '20px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
        [theme.breakpoints.down('xs')]: {
            position: 'unset',
            display: 'block',
            fontSize: '20px',
            fontWeight: '700',
        },
    },
    discountAmount: {
        color: theme.palette.cms?.skuPriceDiscountColor,
        fontWeight: 'normal',
        marginLeft: '10px',
        fontSize: '18px',
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '15px',
        },
    },

    retailPrice: {
        fontSize: '20px',
        color: theme.palette.common?.black,
    },
    selectedRetailPrice: {
        color: theme.palette.common?.black,
        fontSize: '20px',
    },
    productAvailibilityMessage: {
        textTransform: 'uppercase',
        fontSize: '11px',
        fontFamily: theme.typography.fontFamily,
        fontWeight: '700',
        color: theme.palette.productAvailibilityPDP,
        margin: '-2px 0px 0px 0px',
    },
    availabletoShip: {
        textTransform: 'uppercase',
        fontSize: '11px',
        fontFamily: theme.typography.fontFamily,
        fontWeight: '700',
        margin: '-2px 0px 0px 0px',
    },
    productHeaderWrapper: {
        display: 'block',
        padding: '5px 10px',
        // Mobile
        [theme.breakpoints.up(600)]: {
            display: 'none',
        },
    },
    titleAndPrice: {
        display: 'flex',
    },
    title: {
        flex: '4 0 0',
        color: theme.palette.black,
        margin: '0',
        fontSize: '1.25em',
        fontWeight: '500',
    },
    price: {
        flex: '1 0 0',
        textAlign: 'right',
        position: 'relative',
        fontSize: '1em',
        fontWeight: '600',
    },
    productId: {
        margin: '12px 0',
        fontSize: '1em',
        color: theme.palette.colorSecondary,
    },
    availability: {
        color: theme.palette.black,
        padding: '5px 0 10px',
        fontSize: '0.9em',
        boxSizing: 'border-box',
        textAlign: 'center',
        fontWeight: '700',
        textTransform: 'capitalize',
    },
    skuHeader: {
        color: theme.palette.white,
        textAlign: 'left',
        lineHeight: '40px',
        fontWeight: 300,
        paddingLeft: '10px',
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
    },
    pmallPriceContainer: {
        margin: '14.5px 0',
        [theme.breakpoints.down('xs')]: {
            margin: 0,
        },
    },
    pmallDiscountAmount: {
        fontWeight: 700,
        color: '#ae201f',
        [theme.breakpoints.down('xs')]: {
            display: 'block',
        },
    },
    pmallRetailPrice: {
        textDecoration: 'none',
        '& span': {
            textDecoration: 'line-through',
        },
    },
    removeBorder: {
        border: '0px !important', // overwrite the border if upsell flag is enabled
    },
    pmallProductPrice: {
        textAlign: 'right',
        [theme.breakpoints.up('400.5')]: {
            display: 'flex',
            justifyContent: 'end',
        },
        '& span': {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
            [theme.breakpoints.down('1023.5')]: {
                fontSize: '1rem',
                lineHeight: '1.50rem',
            },
        },
        '& $crossedOutRetailPrice': {
            textDecoration: 'line-through',
        },
    },
    skuImage: {
        width: '70px',
        paddingRight: '20px',
        [theme.breakpoints.down('1023.5')]: {
            paddingRight: '15px',
        },
        [theme.breakpoints.down('600.5')]: {
            paddingRight: '11px',
        },
        [theme.breakpoints.down('480.5')]: {
            width: '46px',
        },
    },
    pmallSkuLabelName: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        [theme.breakpoints.down('1023.5')]: {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    baseCode: {
        paddingLeft: '8px',
        [theme.breakpoints.down('767.5')]: {
            marginBottom: '10px',
        },
    },
    pdpListItem: {
        display: 'flex',
        alignItems: 'center',
        '& $skuLabelName': {
            fontSize: '18px',
            lineHeight: '26px',
            letterSpacing: '0.5px',
            fontFamily: 'Poppins',
            marginTop: '3px',
            [theme.breakpoints.down(600)]: {
                fontSize: '16px',
                lineHeight: '24px',
            },
        },
        '& $selectedRetailPrice , $retailPrice': {
            fontSize: '18px',
            lineHeight: '24px',
            letterSpacing: '0.5px',
            fontFamily: 'Poppins',
            marginTop: '3px',
            [theme.breakpoints.down(600)]: {
                fontSize: '16px',
            },
        },
    },
    pdpCustomRadio: {
        padding: '30px 0px 0px',
        '& $formControlRoot': {
            padding: '2px 0px 10px',
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
            '& .MuiRadio-root': {
                color: '#000000',
            },
            '& .MuiRadio-colorSecondary.Mui-checked': {
                color: '#000000',
            },
        },
        [theme.breakpoints.down(600)]: {
            width: 'calc(100% - 32px)',
            margin: '0 auto',
        },
    },
    gridContainer: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down(600)]: {
            padding: '0px 16px',
        },
    },
    productSku: {
        fontSize: '16px',
        lineHeight: '24px',
    },
    resdignWrapper: {
        '@media only screen and (max-width: 767px)': {
            display: 'block !important',
        },
    },
    plaPaperBody: {
        marginBottom: '16px',
    },
});

const round = (value) => Number(`${Math.round(value * 10) / 10}`).toFixed(2);

const GraphqlFoodProductSkus = ({
    classes,
    skuData,
    handleSkuChange,
    trackEvent,
    selectedSku,
    presentation_family,
    location,
    brand,
    product,
    productUrl,
    skuMonths,
    product: { productType, productSkus },
    changeClubMonth,
    changeClubLength,
    clubUpsells,
    changeClubUpsell,
    selectedClubUpsells,
    baseProductSku,
    clubProduct,
    showSkuOnMobile,
    isPassportBundleProduct,
    isPdpYotpoEnabled,
    clubComponents,
    setShippingModalOpen,
    isClubPDPV2,
    isByoProduct,
    isCyoProduct,
    isPdpRedesignEnabled,
    isPdpRedesignSkuEnabled,
    isPlaRedesignEnabled,
    hideUpsells,
    hidePrice,
}) => {
    const { featureFlags = {}, presentation_family: presentationFamily } = useContext(CrossMerch);
    const isSkuShown = clubProduct || (presentationFamily === 'food' && productSkus?.length > 1 && showSkuOnMobile);
    const showPmallSalesPrice = useSelector(getActiveABTest('show_pmall_sales_price'));
    const isMobile = useMediaQuery('(max-width: 767px)');

    // Removing this design from any feature and abtest
    const upsellRedesign = true;
    const isShownDiscountAmount = featureFlags['is_dollar_off_shown_enabled'];
    const ssrDeviceType = useSelector(getSSRDeviceType);
    const styleAdjustRedesign = product?.productSkus?.length > 1 && isPdpRedesignSkuEnabled ? classes.resdignWrapper : '';
    const isPmallProduct = featureFlags['is-pmall-pdp-template-enabled'] && (product?.brand === 'personalizationmall' || product?.brand === 'thingsremembered');
    useEffect(() => {
        if (typeof window !== 'undefined' && typeof window.yotpo !== 'undefined' && typeof window.yotpo.refreshWidgets === 'function') {
            try {
                // Call refresh only if yotpo initialized
                if (window.yotpo.initialized) {
                    window.yotpo.refreshWidgets();
                }
            } catch (exception) {
                mbpLogger.logError({ appName: process.env.npm_package_name, message: 'Unable to refresh the yotpo widget', jsError: exception });
            }
        }
    }, []);
    const renderSkuPrice = (sku, clubPrice = false, pricesList) => {
        if (pricesList && !pricesList?.length) return null; // while prices are still being fetched
        const priceNonSelected = clubPrice ? classes.clubPrice : classes.retailPrice;
        const priceSelected = clubPrice ? classes.clubPriceSelected : classes.selectedRetailPrice;
        let result = null;
        if (pricesList?.length) {
            // dynamic price is active
            // right now just works with subscription dynamic pricing.
            // needs code change to work with pricing tests
            let productPrice = pricesList[0].value;
            let discountedProductPrice = pricesList[1].value;
            if (isPassportBundleProduct?.enable) {
                productPrice = (sku.prices[0].value + isPassportBundleProduct?.prices?.value).toFixed(2);
                discountedProductPrice = (sku.prices[1].value + isPassportBundleProduct?.prices?.value).toFixed(2);
            }
            result = productPrice > discountedProductPrice
                ? (
                    <>
                        <s>
                            ${productPrice}
                        </s>
                        <span className={selectedSku.id !== sku.id ? classes.salePrice : `${classes.salePrice} ${classes.selectedSalePrice}`}>
                            ${discountedProductPrice}
                        </span>
                        {isShownDiscountAmount && (
                            <span className={classes.discountAmount}>
                                ${round(productPrice - discountedProductPrice)} Off
                            </span>
                        )}
                    </>
                )
                : (
                    <span className={selectedSku.id !== sku.id ? priceNonSelected : priceSelected}>
                        ${productPrice}
                    </span>

                );
        } else if ((product?.brandId === '1030' || product?.brandId === '1033') && sku?.prices?.[0] && sku?.prices?.[1] && showPmallSalesPrice === 'VARIANT' && sku.prices[0]?.value > sku.prices[1]?.value) {
            const productPrice = sku.prices[0]?.value;
            const discountedProductPrice = sku.prices[1]?.value;
            result = (
                <div className={classes.pmallPriceContainer}>
                    <s className={`${classes.pmallRetailPrice}`}>
                        was&nbsp;<span>${productPrice}</span>
                    </s>
                    <span className={`${classes.discountAmount} ${classes.pmallDiscountAmount}`}>
                        SALE&nbsp;<span>${discountedProductPrice}</span>
                    </span>
                </div>
            );
        } else if (sku?.prices?.[0] && sku?.prices?.[1]) {
            let productPrice = sku.prices[0].value;
            let discountedProductPrice = sku.prices[1].value;
            if (isPassportBundleProduct?.enable) {
                productPrice = (sku.prices[0].value + isPassportBundleProduct?.prices?.value).toFixed(2);
                discountedProductPrice = (sku.prices[1].value + isPassportBundleProduct?.prices?.value).toFixed(2);
            }
            result = sku.prices[0].value > sku.prices[1].value
                ? (
                    <>
                        <s>
                            ${productPrice}
                        </s>
                        <span className={selectedSku.id !== sku.id ? classes.salePrice : `${classes.salePrice} ${classes.selectedSalePrice}`}>
                            ${discountedProductPrice}
                        </span>
                        {!isPmallProduct && (
                            <span className={classes.discountAmount}>
                                ${round(sku.prices[0].value - sku.prices[1].value)} Off
                            </span>
                        )}
                    </>
                )
                : (
                    <span className={selectedSku.id !== sku.id ? priceNonSelected : priceSelected}>
                        ${productPrice}
                    </span>

                );
        } else if (sku?.prices?.[0]) {
            result = (
                <span className={selectedSku.id !== sku.id ? priceNonSelected : priceSelected}>
                    ${sku.prices[0].value}
                </span>
            );
        }
        return result;
    };

    let { partNumber } = product;
    if (typeof location !== 'undefined') {
        if (location?.search) {
            const queryStr = QueryString.parse(location.search.replace(/^\?/, ''));
            partNumber = queryStr?.baseProductPartNumber || null;
        }
    }
    const productNameRender = isMobile && isPlaRedesignEnabled ?  false : (!isMobile && isByoProduct) || !isByoProduct;
    return (
        // The desktop view and tablet view are same for displaying SKUs
        <>
            <Media
                query={presentationFamily === 'food' ? '(min-width: 768px)' : '(min-width: 699px)'}
            >
                {(matches) => (matches && ssrDeviceType !== 'mobiles' ? (
                    <div className={`${isPlaRedesignEnabled ? classes.plaPaperBody : classes.paperBody}  GraphqlFoodProductSkus`}>
                        <Grid
                            container
                            direction="column"
                            justify="flex-start"
                        >
                            <div className={classes.container}>
                                {isPdpRedesignEnabled && skuData.length > 1 && isPdpRedesignSkuEnabled && presentation_family === 'food' && featureFlags['is-pdp-reviews-enabled'] && featureFlags['is-power-review-enabled'] && (
                                    <ProductReview
                                        product={product}
                                        selectedSku={selectedSku}
                                        productUrl={productUrl} // comes off content from 2 levels up
                                        skuEnabledOnMobile
                                        isStandardPdp
                                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                                        isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                                    />
                                )}
                            </div>
                            <CommonRadioGroup
                                classes={classes}
                                skuData={skuData}
                                handleSkuChange={handleSkuChange}
                                trackEvent={trackEvent}
                                selectedSku={selectedSku}
                                presentation_family={presentation_family}
                                location={location}
                                customizedRadio // passed this parameter to use customized radios
                                product={product}
                                renderSkuPrice={renderSkuPrice}
                                productType={productType}
                                skuMonths={skuMonths}
                                changeClubMonth={changeClubMonth}
                                changeClubLength={changeClubLength}
                                clubUpsells={clubUpsells}
                                selectedClubUpsells={selectedClubUpsells}
                                changeClubUpsell={changeClubUpsell}
                                parentPartNumber={partNumber}
                                baseProductSku={baseProductSku}
                                isPassportBundleProduct={isPassportBundleProduct}
                                productUrl={productUrl}
                                brand={brand}
                                isPdpYotpoEnabled={isPdpYotpoEnabled}
                                upsellRedesign={upsellRedesign}
                                isDynamicPrice
                                clubComponents={clubComponents}
                                setShippingModalOpen={setShippingModalOpen}
                                isClubPDPV2={isClubPDPV2}
                                isCyoProduct={isCyoProduct}
                                isPdpRedesignEnabled={isPdpRedesignEnabled}
                                isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                                isPlaRedesignEnabled={isPlaRedesignEnabled}
                                hideUpsells={hideUpsells}
                                hidePrice={hidePrice}
                            />
                        </Grid>
                    </div>
                )
                    : isSkuShown
                    && (
                        <div className={`${classes.paperBody} GraphqlFoodProductSkus ${styleAdjustRedesign}`}>
                            {!isPdpRedesignEnabled &&  ((featureFlags['is_select_your_item_enabled'] && !isPmallProduct && !clubProduct && !isByoProduct) || (clubProduct && !isClubPDPV2)) && (
                                <div className={classes.skuHeader}>
                                    1. Select Your Item
                                </div>
                            )}
                            <Grid
                                container
                                direction="column"
                                justify="flex-start"
                            >
                                <CommonRadioGroup
                                    classes={classes}
                                    skuData={skuData}
                                    handleSkuChange={handleSkuChange}
                                    trackEvent={trackEvent}
                                    selectedSku={selectedSku}
                                    presentation_family={presentation_family}
                                    location={location}
                                    customizedRadio // used for customized radios
                                    brand={brand}
                                    product={product}
                                    renderSkuPrice={renderSkuPrice}
                                    productType={productType}
                                    skuMonths={skuMonths}
                                    changeClubMonth={changeClubMonth}
                                    changeClubLength={changeClubLength}
                                    clubUpsells={clubUpsells}
                                    selectedClubUpsells={selectedClubUpsells}
                                    changeClubUpsell={changeClubUpsell}
                                    parentPartNumber={partNumber}
                                    baseProductSku={baseProductSku}
                                    isPassportBundleProduct={isPassportBundleProduct}
                                    productUrl={productUrl}
                                    isPdpYotpoEnabled={isPdpYotpoEnabled}
                                    upsellRedesign={upsellRedesign}
                                    isDynamicPrice
                                    clubComponents={clubComponents}
                                    setShippingModalOpen={setShippingModalOpen}
                                    isClubPDPV2={isClubPDPV2}
                                    isCyoProduct={isCyoProduct}
                                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                                    isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                                    hideUpsells={hideUpsells}
                                    hidePrice={hidePrice}
                                />
                            </Grid>
                        </div>
                    ))}
            </Media>
            {!isSkuShown
                ? (
                    <CommonRadioGroup
                        classes={classes}
                        skuData={skuData}
                        handleSkuChange={handleSkuChange}
                        trackEvent={trackEvent}
                        selectedSku={selectedSku}
                        presentation_family={presentation_family}
                        location={location}
                        customizedRadio // used for customized radios
                        brand={brand}
                        product={product}
                        renderSkuPrice={renderSkuPrice}
                        productType={productType}
                        skuMonths={skuMonths}
                        changeClubMonth={changeClubMonth}
                        changeClubLength={changeClubLength}
                        clubUpsells={clubUpsells}
                        selectedClubUpsells={selectedClubUpsells}
                        changeClubUpsell={changeClubUpsell}
                        parentPartNumber={partNumber}
                        baseProductSku={baseProductSku}
                        isPassportBundleProduct={isPassportBundleProduct}
                        productUrl={productUrl}
                        isPdpYotpoEnabled={isPdpYotpoEnabled}
                        upsellRedesign={upsellRedesign}
                        showSkuOnMobile={showSkuOnMobile}
                        productNameRender={productNameRender}
                        isDynamicPrice={!!isMobile}
                        isSkuShown={!isMobile}
                        clubComponents={clubComponents}
                        setShippingModalOpen={setShippingModalOpen}
                        isClubPDPV2={isClubPDPV2}
                        isCyoProduct={isCyoProduct}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                        isPlaRedesignEnabled={isPlaRedesignEnabled}
                        hideUpsells={hideUpsells}
                        hidePrice={hidePrice}
                    />
                )
                : null}
        </>
    );
};

GraphqlFoodProductSkus.defaultProps = {
    skuMonths: {},
    changeClubMonth: () => { },
    changeClubLength: () => { },
    clubUpsells: [],
    brand: {},
    selectedClubUpsells: null,
    changeClubUpsell: () => { },
    baseProductSku: null,
    clubProduct: false,
    showSkuOnMobile: false,
    isPassportBundleProduct: {},
    isPdpYotpoEnabled: false,
    isClubPDPV2: false,
    setShippingModalOpen: false,
    isByoProduct: false,
    isCyoProduct: false,
    isPdpRedesignEnabled: false,
    isPdpRedesignSkuEnabled: false,
    isPlaRedesignEnabled: false,
    hideUpsells: false,
    hidePrice: false,
};

GraphqlFoodProductSkus.propTypes = {
    classes: object.isRequired,
    clubComponents: object.isRequired,
    skuData: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                    __typename: string.isRequired,
                }),
            ).isRequired,
            __typename: string.isRequired,
        }),
    ).isRequired,
    handleSkuChange: func.isRequired,
    selectedSku: shape({
        id: string.isRequired,
        name: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
        __typename: string.isRequired,
    }).isRequired,
    trackEvent: func.isRequired,
    productUrl: string.isRequired,
    product: shape({
        name: string.isRequired,
        partNumber: string.isRequired,
        shortDescription: string.isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }).isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
            productDeliveryType: string.isRequired,
        }).isRequired,
    }).isRequired,
    presentation_family: string.isRequired,
    location: object.isRequired,
    brand: object,
    skuMonths: object, // dynamic month named keys
    changeClubMonth: func,
    changeClubLength: func,
    clubUpsells: clubComponentType,
    selectedClubUpsells: string,
    changeClubUpsell: func,
    baseProductSku: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                    __typename: string.isRequired,
                }),
            ).isRequired,
            __typename: string.isRequired,
        }),
    ),
    clubProduct: bool,
    showSkuOnMobile: bool,
    isPassportBundleProduct: shape({
        enable: bool,
        prices: {},
    }),
    isPdpYotpoEnabled: bool,
    setShippingModalOpen: bool,
    isClubPDPV2: bool,
    isByoProduct: bool,
    isCyoProduct: bool,
    isPdpRedesignEnabled: bool,
    isPdpRedesignSkuEnabled: bool,
    isPlaRedesignEnabled: bool,
    hideUpsells: bool,
    hidePrice: bool,
};
const enhance = compose(
    withStyles(styles),
    withRouter,
);

export default enhance(GraphqlFoodProductSkus);
